import React, { createContext, useContext, useState, useCallback } from "react";

interface VideoPlaybackContextType {
  isStyleSelectorOpen: boolean;
  setStyleSelectorOpen: (open: boolean) => void;
  shouldPauseBackgroundVideos: boolean;
}

const VideoPlaybackContext = createContext<VideoPlaybackContextType | null>(null);

export function VideoPlaybackProvider({ children }: { children: React.ReactNode }) {
  const [isStyleSelectorOpen, setIsStyleSelectorOpen] = useState(false);

  const setStyleSelectorOpen = useCallback((open: boolean) => {
    setIsStyleSelectorOpen(open);
  }, []);

  // Pausar vídeos de fundo quando o seletor de estilos está aberto
  const shouldPauseBackgroundVideos = isStyleSelectorOpen;

  return (
    <VideoPlaybackContext.Provider 
      value={{ isStyleSelectorOpen, setStyleSelectorOpen, shouldPauseBackgroundVideos }}
    >
      {children}
    </VideoPlaybackContext.Provider>
  );
}

export const useVideoPlayback = () => {
  const context = useContext(VideoPlaybackContext);
  if (!context) {
    throw new Error("useVideoPlayback must be used within VideoPlaybackProvider");
  }
  return context;
};

// Hook seguro que não lança erro se usado fora do provider
export const useVideoPlaybackSafe = () => {
  const context = useContext(VideoPlaybackContext);
  return context;
};
